export const bgImageDesktop = require("./shells_header_desktop.png");
export const bgImageTablet = require("./shells_header_tablet.png");
export const bgImageMobile = require("./shells_header_mobile.png");
